import { render, staticRenderFns } from "./VideoAd.vue?vue&type=template&id=926739e0&scoped=true"
import script from "./VideoAd.vue?vue&type=script&lang=js"
export * from "./VideoAd.vue?vue&type=script&lang=js"
import style0 from "./VideoAd.vue?vue&type=style&index=0&id=926739e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926739e0",
  null
  
)

export default component.exports